<template>
  <div class="content-wrapper view-aptlist-manage p-0">
    <div class="content">
      <div class="card">
        <div class="card-body">
          <h4><i class="fas fa-boxes"></i> สินค้าและสต๊อก</h4>

          <div class="row mx-1 my-3">
            <b-form-input
              type="search"
              class="col"
              autofocus
              v-model="filter"
              placeholder="ค้นหาสินค้า จากรหัส หมวดหมู่ หรือชื่อสินค้า"
            ></b-form-input>
            <b-button
              class="col-5 col-sm-4 col-md-3 ml-3"
              variant="primary"
              @click="openProductItemModal()"
            >
              <i class="fas fa-plus"></i> เพิ่มรายการ
            </b-button>
          </div>

          <b-table
            id="productManageTable"
            ref="productManageTable"
            hover
            small
            sort-icon-left
            head-variant="light"
            :items="getProductList"
            :fields="fields"
            :filter="filter"
            :sort-desc="true"
            :responsive="true"
          >
            <template v-slot:cell(index)="row">{{ row.index + 1 }}.</template>
            <template v-slot:cell(productStock)="row">
              {{ row.value }}
              <i class="fas fa-info-circle ml-1"></i>
            </template>

            <template v-slot:cell(buttons)="row">
              <b-button-group class="show-when-hovered" size="xs">
                <b-button
                  variant="outline-secondary"
                  @click="editProduct(row.item)"
                >
                  <i class="fas fa-edit"></i>
                </b-button>
                <b-button
                  v-if="row.item.productStatus === 'ACTIVE'"
                  variant="outline-danger"
                  @click="deleteProduct(row.item)"
                >
                  <i class="fas fa-trash-alt"></i>
                </b-button>
              </b-button-group>
            </template>
          </b-table>
        </div>
      </div>
      <ProductItem ref="productItemModal"></ProductItem>
      <Dialog ref="Dialog"></Dialog>
      <Loading v-if="isLoading"></Loading>
    </div>
  </div>
</template>

<script>
import ProductItem from "../../components/modal/ProductAndStock/ProductItem.vue";
import Dialog from "../../components/modal/Dialog.vue";
import { mapGetters, mapActions } from "vuex";
import Loading from "@/components/Loading";

export default {
  name: "ProductInventory",
  components: {
    ProductItem,
    Dialog,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      fields: [
        {
          key: "index",
          label: "",
        },
        {
          key: "productCode",
          label: "รหัส",
          sortable: true,
        },
        {
          key: "productCatagory.description",
          label: "หมวดหมู่",
          sortable: true,
        },
        {
          key: "productNameMain",
          label: "ชื่อสินค้า",
          sortable: true,
        },
        {
          key: "productNameAdditional",
          label: "ชื่อสินค้าเพิ่มเติม",
          sortable: true,
        },
        {
          key: "productStock",
          label: "จำนวนสต๊อก",
          sortable: true,
          thClass: "px-3",
          tdClass: "px-3",
        },
        {
          key: "productUnit.description",
          label: "หน่วย",
          sortable: true,
          thClass: "px-3",
          tdClass: "px-3",
        },
        {
          key: "productPrice",
          label: "ราคาต้นทุนเฉลี่ย (บาท)",
          sortable: true,
        },
        {
          key: "buttons",
          label: "",
          class: "text-center",
        },
      ],
      filter: null,
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters({
      getProductList: "moduleProductInventory/getProductList",
      getProductUnitList: "moduleUnitMaster/getUnitList",
      getCatagoryList: "moduleCatagoryMaster/getCatagoryList",
    }),
  },
  methods: {
    ...mapActions({
      fetchProductList: "moduleProductInventory/fetchProductList",
      fetchUnitList: "moduleUnitMaster/fetchUnitList",
      fetchCatagoryList: "moduleCatagoryMaster/fetchCatagoryList",
    }),
    async init() {
      this.isLoading = true;
      try {
        await Promise.all([
          this.fetchProductList({
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
          }),

          this.fetchUnitList({
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
          }),

          this.fetchCatagoryList({
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
          }),
        ]);
      } catch (err) {
        this.showDialogToast("danger", "โหลดรายการสินค้าไม่สำเร็จ");
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    openProductItemModal(product = null) {
      this.$refs.productItemModal.show({
        product,
        unitList: this.getProductUnitList,
        catagoryList: this.getCatagoryList,
      });
    },
    editProduct(product) {
      this.openProductItemModal(product);
    },
    deleteProduct(eventData) {
      this.$refs.Dialog.showAlertConfirm(
        "ลบสินค้านี้ ?",
        "คุณต้องการลบสินค้านี้ใช่หรือไม่"
      ).then(result => {
        if (!result.value) return;

        this.$store
          .dispatch("moduleProductInventory/deleteProductItem", {
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
            id: eventData.productId,
          })
          .then(res => {
            if (res.status == 200) {
              this.init();
              this.showDialogToast("success", "ลบรายการสินค้าสำเร็จ");
            }
          })
          .catch(err => {
            const errorMessage = err.response?.data?.errorMessage;

            const errorMsg =
              typeof errorMessage === "string"
                ? errorMessage
                : "ลบรายการสินค้าไม่สำเร็จ กรุณาลองใหม่";

            this.$parent.showDialogToast("danger", errorMsg);
          })
          .finally(() => {
            this.isLoading = false;
          });
      });
    },
    showDialogToast(variant, textDetail) {
      this.$refs.Dialog.showToast(variant, textDetail);
    },
  },
};
</script>

<style scoped></style>
